import NotificationEditor from "./NotificationEditor";

export default function NotificationCreatePage() {
  return <NotificationEditor mode="create" />;
}